import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function LinkIcon({ height = 24, width = 24, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="white"
      {...props}
    >
      <g fill={color}>
        <path d="m7.8 4.35h-3.45v15.0129c1.75665-.1255 4.82989-.3129 7.65-.3129 2.8201 0 5.8934.1874 7.65.3129v-3.1629h1.35v3.965c0 .3301-.2643.5943-.5865.6036l-.0651-.0018c-1.4517-.1129-5.0816-.3668-8.3484-.3668-3.26684 0-6.89674.2539-8.34844.3668-.35093.0273-.65156-.2498-.65156-.6018v-16.565c.00001-.31064.2344-.56633.53672-.59707l.06152-.00293h4.20176z" />
        <path d="m19.7221 2.99707c.7041.00004 1.275.57086 1.275 1.275v6.60003h-1.35v-5.56409l-7.1696 7.16949-.955-.955 7.1754-7.17543h-5.5758v-1.35z" />
      </g>
    </SVGWrapper>
  );
}
export default LinkIcon;
